import React, { Component } from "react";
import LoginPage from "./LoginPage";
import UploadApp from "./UploadApp";
import TopBar from "./TopBar";
import fire from "../index.js";

class MainApp extends Component {
  state = { user: null };

  render() {
    return (
      <React.Fragment>
        <TopBar user={this.state.user}></TopBar>
        {this.state.user ? <UploadApp></UploadApp> : <LoginPage></LoginPage>}
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.authListener();
  }

  authListener() {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          user,
        });
      } else {
        this.setState({ user: null });
      }
    });
  }
}

export default MainApp;
